// Règles de recherche partagées (pages Élèves, Finance, caisse) — identiques à backend/routes/search.py.

/** Minuscules, sans accents : « Léa » → « lea ». */
export const normText = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

const digitsOf = (s) => (s || '').replace(/\D/g, '');

/** Numéro sans indicatif ni 0 initial : « +41 79 000 00 10 », « 079 000 00 10 » → « 790000010 ». */
const national = (d) => {
  if (d.startsWith('0041')) return d.slice(4);
  if (d.startsWith('41') && d.length >= 11) return d.slice(2);
  if (d.startsWith('0')) return d.slice(1);
  return d;
};

/** N'importe quelle suite d'au moins 2 chiffres, dans n'importe quel format, trouve le numéro. */
export function phoneMatches(query, phone) {
  const q = digitsOf(query);
  const p = digitsOf(phone);
  if (q.length < 2 || !p) return false;
  return p.includes(q) || national(p).includes(national(q));
}

/** Un élève correspond-il à la recherche ? (nom, prénom, Instagram avec ou sans @, email, téléphone) */
export function studentMatches(s, query, { contacts = true } = {}) {
  const q = normText(query).trim();
  if (!q) return true;
  const names = [`${s.first_name || ''} ${s.last_name || ''}`, `${s.last_name || ''} ${s.first_name || ''}`];
  if (names.some(n => normText(n).includes(q))) return true;
  if (!contacts) return false;
  const insta = q.replace(/^@/, '');
  if (insta && normText(s.instagram).replace(/^@/, '').includes(insta)) return true;
  if (normText(s.email).includes(q)) return true;
  return phoneMatches(query, s.phone);
}
